module.exports = __webpack_public_path__ + "img/carla.b84efc1a.jpg";